<script>
export default {
  methods: {},
  props: {
    icon: String,
    selected: Boolean,
    disabled: Boolean,
    noRadio: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  computed: {},
};
</script>

<template>
  <div class="f-radio-button-card" :class="{ selected, disabled }" @click="disabled ? null : $emit('click', $event)">
    <div class="f-container">
      <f-icon :icon="icon"></f-icon>
      <div class="f-content">
        <div class="f-title">
          <slot name="title"></slot>
        </div>
        <div class="f-description">
          <slot name="description"></slot>
        </div>
      </div>
      <div class="right">
        <slot name="right"></slot>
      </div>
      <f-radio-button v-if="!noRadio && !disabled" :selected="selected"></f-radio-button>
    </div>
    <div v-if="selected && $slots.more">
      <div class="f-more">
        <slot name="more"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.f-radio-button-card {
  display: flex;
  flex-direction: column;
  outline: 1px solid #dfe6e6;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    outline: 1px solid var(--blue-a50);
  }

  &.selected {
    outline: 2px solid var(--blue);
  }

  .f-container {
    display: flex;
    align-items: center;
    position: relative;

    .f-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      color: var(--turquoise);
      width: 24px;
      height: 24px;
      margin-left: 8px;
    }

    .f-content {
      display: flex;
      flex-direction: column;
      margin: 12px 8px;
      align-items: flex-start;
      flex: 1 1 auto;

      .f-title {
        font-weight: bold;
        font-family: "Lato";
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 110%;
      }

      .f-description {
        margin-top: 2px;
        font-family: "Lato";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 125%;
      }
    }

    .f-radio-button {
      margin: 0 16px;
    }
  }

  .f-more {
    margin-left: 40px;
    margin-right: 16px;
    margin-bottom: 16px;
  }
}

.dark-mode {
  .f-radio-button-card {
    display: flex;
    flex-direction: column;
    outline: 1px solid var(--white-a25);
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      outline: 1px solid var(--navigation-a50);
    }

    &.selected {
      outline: 2px solid var(--navigation);
    }

    &.disabled {
      opacity: 0.75;

      &:hover {
        opacity: 1;
      }
    }

    .f-container {
      .f-icon {
        color: var(--turquoise);
      }
    }

    .f-more {
      margin-left: 16px;
    }
  }
}
</style>